import React from 'react';
import { Snackbar, Typography, IconButton } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import WarningIcon from '@material-ui/icons/Warning';
import { SnackbarOrigin } from '@material-ui/core/Snackbar';
import useStyles from './style';
import { ISnackBarMessagesProps } from './types';

const SnackBarMessages = ({
  message,
  open,
  handleClose,
  type = 'info',
  duration = 1000,
}: ISnackBarMessagesProps) => {
  const classes = useStyles();

  const defaultConfig = React.useMemo<SnackbarOrigin>(
    () => ({
      vertical: 'bottom',
      horizontal: 'center',
    }),
    [],
  );

  const { vertical, horizontal } = defaultConfig;

  const messageContent = React.useCallback(
    (msg: string) => {
      const typedIcons = {
        error: <ErrorIcon aria-label="Ícone de erro" />,
        info: <InfoIcon aria-label="Ícone de informação" />,
        success: <CheckCircleIcon aria-label="Ícone de sucesso" />,
        warning: <WarningIcon aria-label="Ícone de aviso" />,
      };
      return (
        <div className={classes.messageContent}>
          {typedIcons[type]}
          <Typography className={classes.messageText}>{msg}</Typography>
        </div>
      );
    },
    [classes.messageContent, classes.messageText, type],
  );

  const Action = (
    <IconButton
      aria-label="close"
      color="inherit"
      className={classes.close}
      onClick={handleClose}
    >
      <CloseIcon />
    </IconButton>
  );

  if (Array.isArray(message)) {
    return (
      <>
        {message.map((msg, index) => (
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            autoHideDuration={duration}
            open={open}
            onClose={handleClose}
            style={{ marginBottom: `${index * 60}px` }}
            message={messageContent(msg)}
            key={vertical + horizontal}
            className={classes.snackbarBody}
            action={Action}
          />
        ))}
      </>
    );
  }

  return (
    <Snackbar
      anchorOrigin={{ vertical, horizontal }}
      autoHideDuration={duration}
      open={open}
      onClose={handleClose}
      message={messageContent(message)}
      key={vertical + horizontal}
      className={classes.snackbarBody}
      action={Action}
    />
  );
};

export default SnackBarMessages;
